import { render, staticRenderFns } from "./confirm-registration.vue?vue&type=template&id=cbf15a5a&scoped=true&"
import script from "./confirm-registration.vue?vue&type=script&lang=js&"
export * from "./confirm-registration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf15a5a",
  null
  
)

export default component.exports